import ProjectListTable from "../../../components/project/ProjectListTable";

const ProjectListTablePage = () => {
  return <ProjectListTable />;
};

export default ProjectListTablePage;
